export default __webpack_public_path__ + "static/media/3.7cce1b2c.jpg";